import { API } from "../../../services/api-services";

const getPauseStatus = async (setLoader) => {
  try {
    setLoader && setLoader(true);
    const response = await API.get("/student/pause");
    return response;
  } catch (error) {
    console.error("Error fetching pause status:", error);
    return { response: error };
  } finally {
    setLoader && setLoader(false);
  }
};

export default getPauseStatus;
